module.exports = __webpack_public_path__ + "img/block-t-1.6d4c405b.jpg";